export interface CommandPresetConfig {
  host: string
  launchdLabel: string
}

export interface CommandPreset {
  label: string
  script: string
  timeout: number
}

export const DEFAULT_CAPTURE_LAUNCHD_LABEL = 'com.tradval.screencapture'

export function resolveCommandPresetConfig(): CommandPresetConfig {
  return {
    host: import.meta.env.VITE_AGENT_INSTALL_HOST ?? window.location.origin,
    launchdLabel: import.meta.env.VITE_CAPTURE_LAUNCHD_LABEL ?? DEFAULT_CAPTURE_LAUNCHD_LABEL,
  }
}

export function commandPresets({ host, launchdLabel }: CommandPresetConfig): CommandPreset[] {
  return [
    {
      label: 'Restart Capture',
      script: `launchctl kickstart -k gui/$(stat -f '%u' /dev/console)/${launchdLabel}`,
      timeout: 30,
    },
    {
      label: 'Get Logs',
      script: 'tail -50 /var/log/tradval-capture.log',
      timeout: 15,
    },
    {
      label: 'Reinstall Capture',
      script: `curl -fsSL "${host}/api/downloads/install.sh" | SERVER_URL=${host} bash`,
      timeout: 120,
    },
    {
      label: 'System Info',
      script: `sw_vers && uptime && df -h / && launchctl list | grep ${launchdLabel}`,
      timeout: 15,
    },
  ]
}
